module.exports = __webpack_public_path__ + "static/media/hand-point-right.caa36d95.svg";